import React, { useState } from 'react';
import { forgotPassword } from '../../agents/authAgent';
import './AuthPage.css';

/**
 * ForgotPasswordPage: Enter email to receive a password reset link.
 * Calls onBackToLogin() when user wants to return to sign in.
 */
const ForgotPasswordPage = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Forgot password?</h1>
        <p className="auth-subtitle">
          Enter your email and we'll send you a reset link.
        </p>

        {error && (
          <div className="auth-error" role="alert">
            {error}
          </div>
        )}

        {sent ? (
          <div className="auth-success" role="status">
            Check your inbox — if that email has an account, a reset link is on its way.
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label htmlFor="forgot-email" className="auth-label">Email</label>
              <input
                id="forgot-email"
                type="email"
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                disabled={submitting}
              />
            </div>

            <button
              type="submit"
              className="auth-btn-primary"
              disabled={submitting}
            >
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <p className="auth-switch" style={{ marginTop: '16px' }}>
          <button
            type="button"
            className="auth-link-btn"
            onClick={onBackToLogin}
          >
            ← Back to sign in
          </button>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
